export const EOS_FLAG = '-1';
//# sourceMappingURL=constants.js.map